import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'
import { generateDeviceId, registerDevice } from './deviceRegistration'
import { getCurrentApiUrl } from './apiConfig'
import { isWorkingWithData } from '../utils/apiActivity'

export interface DevicePresencePayload {
  deviceId: string
  appName: string
  currentPage: string
  isWorkingWithData: boolean
  isOnline: boolean
  additionalInfo?: string
}

const APP_NAME = 'SmartAccount Web'

let presenceInflight: Promise<void> | null = null

function buildPayload(currentPage: string, isOnline: boolean): DevicePresencePayload {
  return {
    deviceId: generateDeviceId(),
    appName: APP_NAME,
    currentPage,
    isWorkingWithData: isWorkingWithData(),
    isOnline,
    additionalInfo: JSON.stringify({ apiBaseUrl: getCurrentApiUrl() }),
  }
}

export async function reportDevicePresence(
  currentPage: string,
  isOnline: boolean = navigator.onLine
): Promise<void> {
  if (presenceInflight) return presenceInflight

  presenceInflight = (async () => {
    try {
      await apiClient.post(
        API_ENDPOINTS.deviceRegistration.presence,
        buildPayload(currentPage, isOnline),
        { timeout: 8000 },
      )
    } catch (error: unknown) {
      const status = (error as { response?: { status?: number } })?.response?.status
      if (status === 404) {
        try {
          await registerDevice()
          await apiClient.post(
            API_ENDPOINTS.deviceRegistration.presence,
            buildPayload(currentPage, isOnline),
            { timeout: 8000 },
          )
        } catch {
          /* silent */
        }
      }
    }
  })().finally(() => {
    presenceInflight = null
  })

  return presenceInflight
}

export { APP_NAME }
